/**
 * Navigation bar functionality
 * @class
 */
export default class Navigation {
    /**
     * @constructor
     * @param {HTMLElement} element The navigation bar root element
     */
    constructor(element) {
        this.el = element;
        this.components = {
            body: document.querySelector("body"),
            hero: document.querySelector('[data-component="Hero"]'),
            menu: this.el.querySelector('[data-component="Menu"]'),
            preNav: document.querySelector('[data-component="PreNav"]'),
            menuItems: document.querySelector('[data-component="MenuItems"]'),
            searchModal: document.querySelector('[data-component="SearchModal"]'),
        };
        this.buttons = {
            toggle: this.el.querySelector('[data-button="MenuToggle"]'),
            dropdowns: this.el.querySelectorAll('[data-component="DropdownMenu"]'),
            links: this.el.querySelectorAll('[data-button="DropdownLink"]'),
            searchToggleMobile: this.el.querySelector('[data-button="SearchToggleMobile"]'),
            searchToggleDesktop: this.el.querySelector('[data-button="SearchToggleDesktop"]'),
            searchModalCloseDesktop: this.el.querySelector('[data-button="SearchModalCloseDesktop"]'),
        };
        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.buttons.links.forEach((link) => {
            link.addEventListener("click", this.toggleDropdown);
        });
        if (this.buttons.toggle) {
            this.buttons.toggle.addEventListener("click", this.toggleMenu);
        }
        this.handleOutOfBoundryClick();
        const toggleSearchModalMobile = (event) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if ((_a = this.components.menu) === null || _a === void 0 ? void 0 : _a.classList.contains("is-open")) {
                (_b = this.components.menu) === null || _b === void 0 ? void 0 : _b.classList.remove("is-open");
            }
            (_c = this.components.body) === null || _c === void 0 ? void 0 : _c.classList.toggle("is-not-overflowed-y");
            (_d = this.components.preNav) === null || _d === void 0 ? void 0 : _d.classList.toggle("is-open");
            (_e = this.components.searchModal) === null || _e === void 0 ? void 0 : _e.classList.toggle("is-open");
            const searchIconMobile = (_f = this.buttons.searchToggleMobile) === null || _f === void 0 ? void 0 : _f.querySelector('.siteHeader__search-icon');
            const crossIconMobile = (_g = this.buttons.searchToggleMobile) === null || _g === void 0 ? void 0 : _g.querySelector('.siteHeader__cross-icon');
            searchIconMobile === null || searchIconMobile === void 0 ? void 0 : searchIconMobile.classList.toggle("is-hidden");
            if (crossIconMobile === null || crossIconMobile === void 0 ? void 0 : crossIconMobile.classList.contains("is-visible")) {
                crossIconMobile === null || crossIconMobile === void 0 ? void 0 : crossIconMobile.classList.remove("is-visible");
                this.close();
            }
            else {
                crossIconMobile === null || crossIconMobile === void 0 ? void 0 : crossIconMobile.classList.add("is-visible");
            }
            const searchToggleDesktopBtn = this.buttons.searchToggleDesktop;
            if (searchToggleDesktopBtn.disabled == true) {
                searchToggleDesktopBtn.disabled = false;
            }
            else {
                searchToggleDesktopBtn.disabled = true;
            }
        };
        if (this.buttons.searchToggleMobile) {
            this.buttons.searchToggleMobile.addEventListener("click", toggleSearchModalMobile);
        }
        const toggleSearchModalDesktop = (event) => {
            var _a, _b, _c, _d, _e;
            (_a = this.components.body) === null || _a === void 0 ? void 0 : _a.classList.toggle("is-not-overflowed-y");
            (_b = this.components.preNav) === null || _b === void 0 ? void 0 : _b.classList.toggle("is-open");
            (_c = this.components.searchModal) === null || _c === void 0 ? void 0 : _c.classList.toggle("is-open");
            const searchIconMobile = (_d = this.buttons.searchToggleMobile) === null || _d === void 0 ? void 0 : _d.querySelector('.siteHeader__search-icon');
            const crossIconMobile = (_e = this.buttons.searchToggleMobile) === null || _e === void 0 ? void 0 : _e.querySelector('.siteHeader__cross-icon');
            searchIconMobile === null || searchIconMobile === void 0 ? void 0 : searchIconMobile.classList.toggle("is-hidden");
            crossIconMobile === null || crossIconMobile === void 0 ? void 0 : crossIconMobile.classList.toggle("is-visible");
            const searchToggleDesktopBtn = this.buttons.searchToggleDesktop;
            if (searchToggleDesktopBtn.disabled == true) {
                searchToggleDesktopBtn.disabled = false;
            }
            else {
                searchToggleDesktopBtn.disabled = true;
            }
        };
        if (this.buttons.searchToggleDesktop) {
            this.buttons.searchToggleDesktop.addEventListener("click", toggleSearchModalDesktop);
        }
        if (this.buttons.searchModalCloseDesktop) {
            this.buttons.searchModalCloseDesktop.addEventListener("click", toggleSearchModalDesktop);
        }
    }
    handleOutOfBoundryClick() {
        document.addEventListener("mousedown", (e) => {
            var _a, _b, _c;
            const desktop = window.matchMedia("(min-width: 1024px)");
            const isInsideMenuItems = (_a = this.components.menuItems) === null || _a === void 0 ? void 0 : _a.contains(e.target);
            const isInsideSearchModalContainer = (_c = (_b = this.components.searchModal) === null || _b === void 0 ? void 0 : _b.querySelector('[data-component="SearchModalContainer"]')) === null || _c === void 0 ? void 0 : _c.contains(e.target);
            if (desktop.matches && !isInsideMenuItems && !isInsideSearchModalContainer) {
                this.close();
            }
        });
    }
    toggleMenu(event) {
        var _a, _b, _c, _d;
        const el = event.target.closest("[data-Button='MenuToggle']");
        if (el && this.components.menu) {
            el.classList.toggle("is-active");
            (_a = this.components.body) === null || _a === void 0 ? void 0 : _a.classList.toggle("is-not-overflowed-y");
            this.components.menu.classList.toggle("is-open");
            (_b = this.components.preNav) === null || _b === void 0 ? void 0 : _b.classList.toggle("is-open");
            if (this.components.menu.classList.contains("is-open")) {
                (_c = this.components.hero) === null || _c === void 0 ? void 0 : _c.classList.add("hero--transparent");
            }
            else {
                (_d = this.components.hero) === null || _d === void 0 ? void 0 : _d.classList.remove("hero--transparent");
            }
            this.handleKeyUp();
        }
    }
    toggleDropdown(event) {
        var _a, _b, _c;
        const target = event.target;
        const el = target.closest('[data-button="DropdownLink"]');
        const parentEl = el === null || el === void 0 ? void 0 : el.closest('[data-component="DropdownMenu"]');
        const ancestorEl = (_a = parentEl === null || parentEl === void 0 ? void 0 : parentEl.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-component="DropdownMenu"]');
        const dropdowns = [...this.buttons.dropdowns].filter((item) => item !== parentEl && item !== ancestorEl);
        const backdrops = document.querySelectorAll('[data-component="DropdownBackdrop"]');
        el === null || el === void 0 ? void 0 : el.classList.toggle("is-open");
        parentEl === null || parentEl === void 0 ? void 0 : parentEl.classList.toggle("is-open");
        backdrops.forEach((backdrop) => {
            backdrop.scrollTop = 0;
        });
        dropdowns.forEach((item) => {
            item.classList.remove("is-open");
            const links = item.querySelectorAll('[data-button="DropdownLink"]');
            links.forEach(link => link.classList.remove('is-open'));
        });
        // apply opacity to hero component
        if (parentEl === null || parentEl === void 0 ? void 0 : parentEl.classList.contains("is-open")) {
            (_b = this.components.hero) === null || _b === void 0 ? void 0 : _b.classList.add("hero--transparent");
        }
        else {
            (_c = this.components.hero) === null || _c === void 0 ? void 0 : _c.classList.remove("hero--transparent");
        }
        this.handleKeyUp();
    }
    handleKeyUp(evt) {
        if ((evt === null || evt === void 0 ? void 0 : evt.key) === "Escape") {
            this.close();
        }
        else {
            document.addEventListener("keyup", (evt) => this.handleKeyUp(evt), {
                once: true,
            });
        }
    }
    close() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        (_a = this.components.body) === null || _a === void 0 ? void 0 : _a.classList.remove("is-not-overflowed-y");
        (_b = this.buttons.toggle) === null || _b === void 0 ? void 0 : _b.classList.remove("is-active");
        (_c = this.components.menu) === null || _c === void 0 ? void 0 : _c.classList.remove("is-open");
        (_d = this.components.preNav) === null || _d === void 0 ? void 0 : _d.classList.remove("is-open");
        [...this.buttons.links].forEach((item) => item.classList.remove("is-open"));
        [...this.buttons.dropdowns].forEach((item) => item.classList.remove("is-open"));
        (_e = this.components.hero) === null || _e === void 0 ? void 0 : _e.classList.remove("hero--transparent");
        (_f = this.components.searchModal) === null || _f === void 0 ? void 0 : _f.classList.remove("is-open");
        const searchIconMobile = (_g = this.buttons.searchToggleMobile) === null || _g === void 0 ? void 0 : _g.querySelector('.siteHeader__search-icon');
        const crossIconMobile = (_h = this.buttons.searchToggleMobile) === null || _h === void 0 ? void 0 : _h.querySelector('.siteHeader__cross-icon');
        searchIconMobile === null || searchIconMobile === void 0 ? void 0 : searchIconMobile.classList.remove("is-hidden");
        crossIconMobile === null || crossIconMobile === void 0 ? void 0 : crossIconMobile.classList.remove("is-visible");
        const searchToggleDesktopBtn = this.buttons.searchToggleDesktop;
        searchToggleDesktopBtn.disabled = false;
    }
    /**
     * Creates new instances of INavigationUtils for each `[data-component="Navigation"]` element,
     * and adds the necessary event listeners to support opening and closing of the navigation.
     */
    static init() {
        const NavigationEl = document.querySelector('[data-component="Navigation"]');
        if (NavigationEl) {
            const NavigationUtil = new Navigation(NavigationEl);
        }
    }
}
